function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
import { format, formatDistanceToNow, differenceInHours, differenceInDays, isThisYear } from 'date-fns';
import { ko } from 'date-fns/locale';
/**
 * 날짜를 적절한 형식으로 변환하는 함수
 * 
 * 24시간 이내: "5분 전", "2시간 전"
 * 올해 작성된 게시물: "5월 12일"
 * 이전 게시물: "2022년 5월 12일"
 */ export var getFormattedDate = function(date) {
    try {
        var dateObj = _instanceof(date, Date) ? date : new Date(date);
        var now = new Date();
        var hoursAgo = differenceInHours(now, dateObj);
        var daysAgo = differenceInDays(now, dateObj);
        // 24시간 이내: 상대적 시간 표시 ("5분 전", "2시간 전")
        if (hoursAgo < 24) {
            return formatDistanceToNow(dateObj, {
                addSuffix: true,
                locale: ko
            });
        }
        // 올해 작성된 게시물이지만 24시간 이후: 월/일 형식 (예: "5월 12일")
        if (isThisYear(dateObj) && daysAgo < 365) {
            return format(dateObj, 'M월 d일', {
                locale: ko
            });
        }
        // 작년 이전 게시물: 연/월/일 형식 (예: "2022년 5월 12일")
        return format(dateObj, 'yyyy년 M월 d일', {
            locale: ko
        });
    } catch (error) {
        console.error('[SocialPost] 날짜 형식 오류:', error);
        return '';
    }
};
/**
 * navigatePath를 결정하는 함수
 */ export var getNavigatePath = function(path, id) {
    return path || "/post/".concat(id);
};
/**
 * 두 ref를 합치는 함수
 */ export var combineRefs = function(element, ref1, ref2) {
    if (ref1) {
        // @ts-ignore - 타입 무시
        ref1.current = element;
    }
    if (ref2) {
        // @ts-ignore - 타입 무시
        ref2.current = element;
    }
};
